import React, { useContext, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import Header from "../../components/headerAdmin/Header.js";
import "./pendingInvites.css";
import getAllPendingCandidateByInvitedIdResponse from "../../apis/pendingInvites/pendingInvites";
import getAllPendingCandidatesByOrganizationId from "../../apis/pendingInvites/pendingInvitesByOrganizationId.js"
import { useLocation, useNavigate } from "react-router-dom";
import { DateTime } from "luxon";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { NotificationManager } from "react-notifications";
import SearchReferralByRecruitmentPartnerId from '../../apis/myTallentCommunityByOrgId/searchReferralByRecruitmentPartnerId.js';
import UpdateStatusReferralById from '../../apis/myTallentCommunityByOrgId/updateStatusReferralById.js';
import revokeInviteCandidateResponse from '../../apis/inviteCandidate/revokeInviteCandidate.js';
import { UserTypeContext } from '../../AppRoute.js';
import DataTable from '../../components/DataTable/DataTable.js';
import Tooltip from "@mui/material/Tooltip";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess.js';
const styleSx = {
  fontRoboto: {
    fontFamily: "Roboto,sans-serif",
  },
}

const PendingInvites = (props) => {
  const location = useLocation();
  const allPendingCandidateByInvitedIdArr = [];
  const allPendingCandidateByOrgId = []
  const { userType, userRecords } = useContext(UserTypeContext);
  const userRecruitmentpartnerId = userType === "Admin" ? location?.state?.userRecruitmentpartnerId : userRecords?.recruitmentpartnerId
  const idContextTest = userType === "Admin" ? location?.state?.id : userRecords?.id
  const userRole = userType === "Admin" ? location?.state?.userRole : userRecords?.role?.roleName
  const userRecordData = userType === "Admin" ? location?.state?.userRecords : userRecords
  const history = useNavigate();
  const [revokeCandidateDetails, setRevokeCandidateDetails] = useState({});
  const [pendingData, setPendingData] = useState([]);
  const [pendingDataByOrgId, setPendingDataByOrgId] = useState([])
  const [openRevokeDialogue, setOpenRevokeDialogue] = useState(false);
  const [revokeReferral, setRevokeReferral] = useState([]);
  const [isloading, setIsloading] = useState(false);

  const [dataResult, setDataResult] = useState(allPendingCandidateByInvitedIdArr);
  const [dataResult1, setDataResult1] = useState(allPendingCandidateByOrgId);
  const getAllPendingCandidateByInvitedId = async () => {

    if (userRole === 'Recruiter' || userRole === "Recruitment Leader" || userRole === "Team Leader") {
      var rId = idContextTest;
      let payload = {
        userType: userRole
      }
      let allPendingCandidateByInvitedId = await getAllPendingCandidateByInvitedIdResponse(rId, payload);

      if (allPendingCandidateByInvitedId?.data?.data) {
        let arr = [];
        let data = allPendingCandidateByInvitedId?.data?.data;

        if (data.length > 0) {
          for (let index = 0; index < data.length; index++) {
            //Aging
            let date = getDate(data[index].createdAt);
            let dateOfInvite = data[index].createdAt;
            let currentDate = DateTime.now().toISO();
            const date1 = DateTime.fromISO(dateOfInvite);
            const date2 = DateTime.fromISO(currentDate);
            const diff = date2.diff(date1, ["days"]).toObject();
            const difference = diff.days.toString().split(".")[0].includes("-")
              ? 0
              : diff.days.toString().split(".")[0];

            // Test Expiry Date
            const formattedDate = DateTime.fromISO(data[index].expiresOn)
              .toLocal()
              .startOf("day")
              .toJSDate();

            arr.push(
              Object.assign(data[index], {
                dateTime: date,
                aging: difference,
                testExpiry: formattedDate,
              })
            );
          }

          setPendingData(arr);
          setDataResult(arr)
          // setDataResult(process(arr, dataState));

        }
      } else {
        const emptArr = [];

        setPendingData([]);
        setDataResult(emptArr);
        // setDataResult(process(emptArr, dataState));

      }
    } else {
      var oId = userRecruitmentpartnerId;
      let allPendingCandidateByOrgId = await getAllPendingCandidatesByOrganizationId(oId)

      if (allPendingCandidateByOrgId.data.data) {
        let arr = [];
        let data = allPendingCandidateByOrgId.data.data;

        if (data.length > 0) {
          for (let index = 0; index < data.length; index++) {
            //Aging
            let date = getDate(data[index].createdAt);
            let dateOfInvite = data[index].createdAt;
            let currentDate = DateTime.now().toISO();
            const date1 = DateTime.fromISO(dateOfInvite);
            const date2 = DateTime.fromISO(currentDate);
            const diff = date2.diff(date1, ["days"]).toObject();
            const difference = diff.days.toString().split(".")[0].includes("-")
              ? 0
              : diff.days.toString().split(".")[0];

            // Test Expiry Date
            const formattedDate = DateTime.fromISO(data[index].expiresOn)
              .toLocal()
              .startOf("day")
              .toJSDate();

            arr.push(
              Object.assign(data[index], {
                dateTime: date,
                aging: difference,
                testExpiry: formattedDate,
              })
            );
          }
          setPendingDataByOrgId(arr);
          setDataResult1(arr);
        }
      } else {
        const emptArr = [];
        setPendingDataByOrgId([]);
        setDataResult1(emptArr);
      }
    }

  };


  const getDate = (date) => {
    let fullDate = "";
    fullDate =
      new Intl.DateTimeFormat("en", { day: "2-digit" }).format(new Date(date)) +
      "-" +
      new Intl.DateTimeFormat("en", { month: "long" }).format(new Date(date)) +
      "-" +
      new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        new Date(date)
      ) +
      ", " +
      new Date(date).toLocaleTimeString(navigator.language, {
        hour: "2-digit",
        minute: "2-digit",
      });

    return fullDate;
  };


  useEffect(() => {
    if (userRecruitmentpartnerId) {
      getAllPendingCandidateByInvitedId();
    }
  }, [userRecruitmentpartnerId , userType]);

  const goToDashboard = () => {
    history("/dashboard",
      {
        state: {
          userType: userType,
          recruitmentPartnerId: userRecruitmentpartnerId,
          id: idContextTest,
          userRecords: userRecordData,
          roleName: userRole
        }
      });
  }


  const openRevokeModal = (value) => {
    setRevokeCandidateDetails(value);
    setOpenRevokeDialogue(true);
    getReferralData(value);
  };

  const closeRevokeModal = () => {
    setOpenRevokeDialogue(false);
  };

  const revokeCandidate = async () => {
    if (revokeReferral.length !== 0) {
      const payload = {
        referralId: revokeReferral[0]?.id,
        data: {
          status: "Referral Cancelled",
        },
      };

      try {
        await UpdateStatusReferralById(payload);
      } catch (err) {
        NotificationManager.error("Something Went Wrong!", "error", 10000)
      }
    }

    var payload = {
      isActive: false,
    };

    try {
      await revokeInviteCandidateResponse(
        revokeCandidateDetails.id,
        payload
      );
      NotificationManager.success("Revoke done", "Success", 10000);
      getAllPendingCandidateByInvitedId();
      setOpenRevokeDialogue(false);
    } catch (error) {
      NotificationManager.error("Revoke failed", "Error", 10000);
      setOpenRevokeDialogue(false);
    }
  };

  // Date filter function
  function dateFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.original.expiresOn;
    if (!rowValue) return false;

    try {
      const rowDate = new Date(rowValue);
      const filterDate = new Date(filterValue);

      // Reset time to start of day for both dates to compare only date part
      rowDate.setHours(0, 0, 0, 0);
      filterDate.setHours(0, 0, 0, 0);

      return rowDate.getTime() === filterDate.getTime();
    } catch (error) {
      console.warn('Date filtering error:', error);
      return false;
    }
  }

  const getDateFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    return filterValue ? new Date(filterValue) : null;
  }
  const getReferralData = async (param) => {

    const payloadDataForReferral = {
      recruitmentPartnerId: userRecruitmentpartnerId,
      data: {
        skillId: [],
        country: "",
        status: [],
      },
    };
    try {
      let res = await SearchReferralByRecruitmentPartnerId(
        payloadDataForReferral
      );
      const allData = res?.data?.data;
      res = allData;
      res = res.filter((item, i) => item.email === (param.email ? param.email : ""));
      setRevokeReferral(res || []);

    } catch (err) {
      NotificationManager.error("Something Went Wrong!", "error", 10000)
    }

  };

  const columns = [
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => (

        <td>
          <div className="revokeButtonAllignment">
            <Button
              sx={styleSx.fontRoboto}
              type="button"
              size="small"
              variant="contained"
              className='revokeButton_pendingInvites'
              onClick={() => {
                openRevokeModal(row.original);
              }
              }
            >
              Revoke
            </Button>
          </div>
        </td>

      ),
      size: 120,
      enableSorting: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "firstName",
      header: "First Name",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "lastName",
      header: "Last Name",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "email",
      header: "Email",
      size: 180,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "test.testName",
      header: "Test",
      size: 180,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "test.skill.name",
      header: "Skill",
      size: 180,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "aging",
      header: "Aging (Days)",
      size: 180,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "user.displayName",
      header: "Invited By",
      size: 180,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "Date",
      header: "Test Expiry Date",

      filterFn: dateFilterFn,
      Filter: ({ column }) => (
        <div className="date-picker-filter-container">
          <DatePicker
            selected={getDateFilterValue(column)}
            onChange={(date) => {
              column.setFilterValue(date ? date.toISOString() : '');
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText="Select date"
            // maxDate={new Date()}
            isClearable
            showIcon={true}
            className="date-picker-table-filter"
          />
        </div>
      ),
      cell: ({ row }) => (

        <>
          {DateTime.fromISO(row.original.expiresOn)
            .toFormat("MM/dd/yyyy")
            .toString()}
        </>

      ),
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
    },

  ]

  return (
    <>
      {(userType === "Candidate") ? (
         <UnauthorizedAccess />
      ) :
        <div className='pendingInvitemainContainer'>
          <div className='pendingInviteTopContainer'>
            <Grid size={{ xs: 12 }}>
              <Header />
            </Grid>
            <div className="pendingInviteMainGrid">
              <div className="communityHeader_invites">
                <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                  <Tooltip title="Go Back to Dashboard" placement="bottom">
                    <ArrowBackIcon sx={{ fontSize: 20 }} />
                  </Tooltip>
                </div>
                <div className="communityTitle">Pending Invites</div>
              </div>
              <DataTable
                data={userRole === 'Recruiter' || userRole === "Recruitment Leader" || userRole === "Team Leader" ? dataResult : dataResult1}
                //  data={userRole === 'Recruiter' || userRole === "Recruitment Leader" || userRole === "Team Leader" ? dataStateChange?.data : dataStateChange1?.data}
                columns={columns}
                isLoading={isloading}
              />
            </div>
          </div>
          
        </div>
      }

      <Dialog
        open={openRevokeDialogue}
        onClose={closeRevokeModal}
        aria-labelledby="customized-dialog-title"
      >
        <DialogContent
          sx={styleSx.bodyForRemove}
          className="removemodal_responsive"
        >
          <div className="text-center fs-semi-bold f-color fs-18">
            Do you want to revoke invite?
          </div>
        </DialogContent>
        <DialogActions
          sx={styleSx.buttonAlignForRemove}
          className="responsiveRemove_Modal_button"
        >
          <div className="remove_modal revoke_adjust">
            <button
              type="button"
              className="btn_remove btn-skill cp"
              onClick={closeRevokeModal}
            >
              No
            </button>
            <button
              type="button"
              className="btn2 btn-green ml_5 cp"
              onClick={revokeCandidate}
            >
              Yes
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default PendingInvites

